import { PropsWithChildren } from 'react';
import React from 'react';

import cs from 'classnames';
import { isNil } from 'ramda';
import { FieldPath } from 'react-hook-form';

import { AdapterType } from 'utils/types';

import { DatePickerPopover } from '../../DatePickerPopover';
import s from '../index.module.css';
import { DefaultValuePlank } from './shared';
import { NightsCountPlank } from './shared/NightsCountPlank';
import { FieldValues, TInputDatePickerProps as Props } from './type';

const InputDatePicker = function <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>(props: AdapterType<TFieldValues, TName> & PropsWithChildren<Props>) {
  const {
    children,
    field: { value },
    fieldState: { error },
    mode,
    placeholder,
  } = props;

  const hasError = !!error;

  const isEmpty = React.useMemo(() => {
    if (mode === 'range') return isNil(value) || isNil(value.start);
    return isNil(value);
  }, [value]);

  return (
    <DatePickerPopover {...props}>
      <div className={cs(s.plank, { [s.errorBorder]: hasError })}>
        {placeholder && <span className={cs(s.placeholder, { [s.empty]: isEmpty })}>{placeholder}</span>}
        {!isEmpty && (children || <DefaultValuePlank {...props} />)}
      </div>
    </DatePickerPopover>
  );
};

InputDatePicker.NightsCountPlank = NightsCountPlank;

export { InputDatePicker };
